import logger from '3-foundation/Logging/logger';
import { mapFirstImage } from '../DataTypes/imageMapper';
import { mapFirstLink } from '../DataTypes/linkMapper';
import { mapFirstVideo } from '../DataTypes/videoMapper';

interface Props {
	content: {
		contentType: 'headerCard';
		properties: {
			kicker: string;
			teaser: { markup: string };
			heading: string;
			image: Umbraco.Image[];
			imageAltText: string;
			link: Umbraco.Link[];
			video: Umbraco.Video[];
		};
	};
}

export const mapHeaderCard = ({ content }: Props): Content.HeaderCard => {
	const { kicker, teaser, heading, link, image, imageAltText, video } = content?.properties ?? {};
	try {
		return {
			documentType: content?.contentType,
			content: {
				kicker,
				teaser: teaser?.markup || null,
				heading,
				link: mapFirstLink(link),
				image: mapFirstImage(image) ?? null,
				video: mapFirstVideo(video) ?? null,
				imageAltText: imageAltText,
			},
		};
	} catch (e) {
		logger.error('Could not map HeaderCard', e);
		throw new Error('Could not map HeaderCard', e);
	}
};
